import { useForm } from 'react-hook-form';

import { IFacility } from 'common/src/types/interfaces';

import { FormContainer } from 'portal/src/components/common/forms/FormContainer';
import GenericDialog from 'portal/src/components/common/GenericDialog';

import {
  defaultValues,
  getFacilityProjectFields,
} from './FacilityProjectForm.fields';

const FacilityFormDialog = ({
  entity = {},
  facilities = [],
  onClose,
  onSave,
  open,
}: {
  entity?: any;
  facilities: IFacility[];
  onClose: () => void;
  onSave: (data: any) => void;
  open: boolean;
}) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { isDirty },
  } = useForm({
    defaultValues: defaultValues(entity),
  });

  const handleClose = () => {
    reset(defaultValues(entity));
    onClose();
  };

  const isNew = Object.keys(entity).length === 0;

  return (
    <GenericDialog open={open} onClose={handleClose}>
      <FormContainer
        header={isNew ? 'Add Facility' : 'Edit Facility'}
        backButtonlabel="Cancel"
        buttonLayout="bottom"
        control={control}
        isDirty={isDirty}
        isNew={isNew}
        isPending={false}
        isSubmitDisabled={false}
        mainFieldsConfig={getFacilityProjectFields(facilities)}
        handleBackAction={handleClose}
        handleSubmit={handleSubmit((data: any) => onSave(data))}
        removeContainerStyle={true}
      />
    </GenericDialog>
  );
};

export default FacilityFormDialog;
